const JsonBlock = ({ value }) => (
  <pre className="max-h-48 overflow-auto rounded-lg bg-gray-50 p-3 text-xs text-text-secondary">
    {JSON.stringify(value, null, 2)}
  </pre>
);

export default JsonBlock;
